import React from 'react'
import Information from './Types/Information'

const ShippingUpdate = () => {
  const title = 'Shipping Update'
  const message = `
      As major carriers like FedEx and UPS have acknowledged,
      unprecedented demand may cause 1-2 day shipping delays
      from the ETA given at checkout.
      We apologize for any inconvenience.
    `

  return (
    <Information
      title={title}
      message={message}
      borderColor="#4A90E2"
    />
  )
}

export default ShippingUpdate
